var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.42 22.5l1.52 1.5 8-8-8-8-1.52 1.52 5.52 5.42h-17.080v2.14h17zM6.6 0v9.6h2.14v-7.46h19.26v27.72h-19.26v-7.46h-2.14v9.6h23.54v-32z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/login-icon.3fb42962a571c3ad679b298e9c82276e.svg";
export { ForwardRef as ReactComponent };